import configureStoreDev from "./store.dev";
import configureStoreProd from "./store.prod";

import initialState from "./reducers/initialState";

// const store = configureStoreProd(initialState);

// is mobile - check this using user agent
const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

const store =
  process.env.NODE_ENV === "production" || isMobile
    ? configureStoreProd(initialState)
    : configureStoreDev(initialState);

export default store;
